import React from "react";
import { ValidationLogPanel } from "@/components/authority/KarateAuthorityDocumentsPanels.jsx";

export function DocumentsPreuvesJournalPage() {
  return (
    <div data-testid="page-admin-documents-preuves-journal">
      <ValidationLogPanel testId="documents-preuves-journal-panel" />
    </div>
  );
}
